const ActionToolEnum = {
  bulk_operation: "bulk_operation",
  export_report: "export_report",
  import_export_geozones: "import_export_geozones",
  legal_document_send: "legal_document_send",
  import_tracker_settings: "import_tracker_settings",
  import_cellular: "import_cellular",
  export_cellular: "export_cellular",
  import_infrastructure_settings: "import_infrastructure_settings",
};

export default ActionToolEnum;
